'use client';

/**
 * @packageDocumentation
 * @category Component
 */

import { AuthProvider } from '@bomdisoft/auth-bff';
import { GlobalProgressIndicator, NotificationProvider, ThemeProvider } from '@bomdisoft/components';
import { ReactNode } from 'react';

export type ProvidersProps = {
  children: ReactNode;
};

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <ThemeProvider>
      <NotificationProvider>
        {/* `oidc` is required: pieleaf runs its own BFF, so /api/auth/me verifies
            the token here. Without it the provider asks an external auth host via
            getAuthBaseUrl(), which throws when the URL env is unset, and its own
            catch turns that into "signed out", silently logging every visitor out. */}
        <AuthProvider oidc>
          {children}
          <GlobalProgressIndicator />
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
};
